import { useHistory } from 'react-router';
import Header from '../../../components/layout/Header';
import Button from '../../../components/Button';
import { Table, TableColumnsType } from 'antd';
import useAxios from '../../../hooks/useAxios';
import { IGetSpeakingItems } from '../../../models/speaking.model';
import { useEffect } from 'react';
import { getSpeakingItems } from '../../../api/speaking.api';
import Loader from '../../../components/Loader';
import ErrorResponse from '../../../components/ErrorResponse';
import { useTranslation } from 'react-i18next';

const CbtSpeakingItem = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { data: res, isLoading, error, execute } = useAxios<IGetSpeakingItems>();

  useEffect(() => {
    execute(getSpeakingItems());
  }, []);

  const columns: TableColumnsType<any> = [
    {
      title: t('cbt.speakingItem.2'),
      dataIndex: 'evaluationItemName',
      key: 'evaluationItemName',
      align: 'center',
      sorter: (a, b) => a.evaluationItemName?.localeCompare(b.evaluationItemName),
    },
    {
      title: t('cbt.speakingItem.3'),
      dataIndex: 'useYn',
      key: 'useYn',
      align: 'center',
      sorter: (a, b) => a.useYn?.localeCompare(b.useYn),
    },
    {
      title: t('cbt.speakingItem.4'),
      key: 'memo',
      dataIndex: 'memo',
      align: 'center',
      sorter: (a, b) => a.memo?.localeCompare(b.memo),
    },
  ];

  return (
    <div className="content-wrapper">
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <Header
        iconFile="icon-cbt-big.svg"
        parentMenu="CBT"
        currentMenu={t('cbt.speakingItem.6')}
      />

      <div className="main max-w1200p">
        <div className="text-right">
          <Button
            className='btn btn-primary ml-2 btn-w100p'
            onClick={() => history.push('/cbt/speaking-item/create')}
            text={t('cbt.speakingItem.7')}
          />
        </div>
        <div>
          <Table
            columns={columns}
            dataSource={res?.data || undefined}
            pagination={{
              pageSize: 99999
            }}
            onRow={record => {
              return {
                onClick: () => {
                  history.push(`/cbt/speaking-item/${record.evaluationItemCode}/edit`);
                }
              };
            }}
            rowClassName="pointer"
          />
        </div>
        <div className="text-right">
          <Button
            className='btn btn-primary ml-2 btn-w100p'
            onClick={() => history.push('/cbt/speaking-item/create')}
            text={t('cbt.speakingItem.7')}
          />
        </div>

      </div>
    </div>
  );
}

export default CbtSpeakingItem;
